import React from "react";
import { Box, useTheme } from "@mui/material";
import CustomTypography from "../../../../../views/components/common/form/CustomTypography";

export interface PipelineItemDetailsProps {
  type: "lead" | "deal";
  lastActive: string;
  owner: string;
  company: string;
  source: string;
  orderId: string;
  value: string;
  firstActive: string;
  discount?: string;
  heading?: string;
}

const labelStyle = {
  marginRight: 6,
  minWidth: 80,
  display: "inline-block",
};

const itemStyle = {
  marginTop: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const PipelineItemDetailsCard: React.FC<PipelineItemDetailsProps> = React.memo(
  ({
    type,
    lastActive,
    owner,
    company,
    source,
    orderId,
    value,
    firstActive,
    discount,
    heading,
  }) => {
    const theme = useTheme();

    return (
      <Box
        sx={{
          p: 2,
          minWidth: 220,
          borderRadius: 2,
          boxShadow: 3,
          bgcolor: "background.paper",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          mb={1}
          justifyContent="space-between"
        >
          <CustomTypography fontWeight={500} variant="heading7">
            {heading}
          </CustomTypography>
        </Box>
        <hr
          style={{
            border: `1px solid ${theme.palette.customColors.lightGreyColor}`,
          }}
        />
        <Box sx={itemStyle}>
          <CustomTypography
            sx={labelStyle}
            fontWeight={400}
            variant="body3"
            color={theme.palette.customColors.greyTextColor}
          >
            Last Active:
          </CustomTypography>
          <CustomTypography
            variant="body3"
            fontWeight={500}
            color={theme.palette.customColors.darkBlueText}
          >
            {lastActive}
          </CustomTypography>
        </Box>
        <Box sx={itemStyle}>
          <CustomTypography
            sx={labelStyle}
            fontWeight={400}
            variant="body3"
            color={theme.palette.customColors.greyTextColor}
          >
            Owner:
          </CustomTypography>
          <CustomTypography
            variant="body3"
            fontWeight={500}
            color={theme.palette.customColors.darkBlueText}
          >
            {owner}
          </CustomTypography>
        </Box>
        <Box sx={itemStyle}>
          <CustomTypography
            sx={labelStyle}
            fontWeight={400}
            variant="body3"
            color={theme.palette.customColors.greyTextColor}
          >
            Company:
          </CustomTypography>
          <CustomTypography
            variant="body3"
            fontWeight={500}
            color={theme.palette.customColors.darkBlueText}
          >
            {company}
          </CustomTypography>
        </Box>
        <Box sx={itemStyle}>
          <CustomTypography
            sx={labelStyle}
            fontWeight={400}
            variant="body3"
            color={theme.palette.customColors.greyTextColor}
          >
            Source:
          </CustomTypography>
          <CustomTypography
            variant="body3"
            fontWeight={500}
            color={theme.palette.customColors.darkBlueText}
          >
            {source}
          </CustomTypography>
        </Box>
        <Box sx={itemStyle}>
          <CustomTypography
            sx={labelStyle}
            fontWeight={400}
            variant="body3"
            color={theme.palette.customColors.greyTextColor}
          >
            Order ID:
          </CustomTypography>
          <CustomTypography
            variant="body3"
            fontWeight={500}
            color={theme.palette.customColors.darkBlueText}
          >
            {orderId}
          </CustomTypography>
        </Box>
        <Box sx={itemStyle}>
          <CustomTypography
            sx={labelStyle}
            fontWeight={400}
            variant="body3"
            color={theme.palette.customColors.greyTextColor}
          >
            Value:
          </CustomTypography>
          <CustomTypography
            variant="body3"
            fontWeight={500}
            color={theme.palette.customColors.darkBlueText}
          >
            {value}
          </CustomTypography>
        </Box>
        <Box sx={itemStyle}>
          <CustomTypography
            sx={labelStyle}
            fontWeight={400}
            variant="body3"
            color={theme.palette.customColors.greyTextColor}
          >
            First Active:
          </CustomTypography>
          <CustomTypography
            variant="body3"
            fontWeight={500}
            color={theme.palette.customColors.darkBlueText}
          >
            {firstActive}
          </CustomTypography>
        </Box>
        {discount && (
          <Box sx={itemStyle}>
            <CustomTypography
              sx={labelStyle}
              fontWeight={400}
              variant="body3"
              color={theme.palette.customColors.greyTextColor}
            >
              Discount:
            </CustomTypography>
            <CustomTypography
              variant="body3"
              fontWeight={500}
              color={theme.palette.customColors.darkBlueText}
            >
              {discount}
            </CustomTypography>
          </Box>
        )}
      </Box>
    );
  }
);

export default PipelineItemDetailsCard;
